import { CustomFieldConditionEnum } from './custom-field-condition.enum';

chooseConditionsOnCustomFieldsController.$inject = ['$scope', '$mdDialog', 'elementData', 'context'];

export function chooseConditionsOnCustomFieldsController($scope, $mdDialog, elementData, context) {

    $scope.ok = ok;
    $scope.cancel = cancel;
    $scope.context = context;
    $scope.formChanged = formChanged;
    $scope.invalid = true;
    $scope.customFieldDropdownItems = [];

    _init();

    function _init() {
        _initDropdownItems();
        $scope.elementData = elementData;
    }

    function _initDropdownItems() {
        context.operatorsExcluded = [CustomFieldConditionEnum.IS_NULL, CustomFieldConditionEnum.NOT_EQUAL]
        $scope.customFieldDropdownItems = context.customFields
            // The supported types for now.
            .filter(field => field?.type?.type && ['integer', 'float', 'boolean', 'string', 'email', 'url', 'phone', 'date', 'datetime', 'enum'].includes(field.type.type))
            .map(field => ({
                label: `${field.label} (${field.scope} field - ${field.type.type})`,
                id: field.id,
            }));
    }

    function formChanged(value) {
        $scope.elementData = value;
        const { selectedCustomField, selectedCondition, comparedValue } = $scope.elementData;
        const invalidComparedValue = selectedCondition !== CustomFieldConditionEnum.IS_NOT_NULL && selectedCondition !== CustomFieldConditionEnum.IS_NULL && comparedValue === null;
        $scope.invalid = !selectedCustomField || !selectedCondition || invalidComparedValue;
    }

    function ok() {
        const customField = context.customFieldsMap.get($scope.elementData.selectedCustomField);
        const { selectedCustomField, selectedCondition, comparedValue } = $scope.elementData;
        $scope.elementData = {
            selectedCustomField,
            selectedCondition,
            selectedCustomFieldType: customField.type.type,
            comparedValue,
        }

        $mdDialog.hide({ type: 'ok', data: $scope.elementData });
    }

    function cancel() {
        $mdDialog.cancel();
    }
}

